import styled from "styled-components";

export const SOnboardingTourCardButtonWrapper = styled.div`
  width: fit-content;
`;
